/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoredAddressTypeCreateMany } from '../../models/stored-address-type-create-many';
import { StoredAddressTypesListResponse } from '../../models/stored-address-types-list-response';

export interface CreateStoredAddressTypes$Params {
      body: StoredAddressTypeCreateMany
}

export function createStoredAddressTypes(http: HttpClient, rootUrl: string, params: CreateStoredAddressTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<StoredAddressTypesListResponse>> {
  const rb = new RequestBuilder(rootUrl, createStoredAddressTypes.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoredAddressTypesListResponse>;
    })
  );
}

createStoredAddressTypes.PATH = '/api/v1/address_types';
